import { useState, useEffect } from 'react';
import { convertTimestampToDate } from '../util/DateTimeUtil';

import NullCheckUtil from '../util/NullCheckUtil';

const EnrolmentProcessStatus = ({ semesterInfo }) => {
    const currentTimestamp = new Date().getTime();

    const STEP_START = 'apply-step-items step-start ';
    const STEP_CONT = 'apply-step-items step-continue ';
    const STEP_END = 'apply-step-items step-end ';
    const DONE = ' done';
    const ACTIVE = ' active';

    const [step01Status, setStep01Status] = useState('');
    const [step02Status, setStep02Status] = useState('');
    const [step03Status, setStep03Status] = useState('');

    useEffect(() => {
        if (NullCheckUtil.isNotNull(semesterInfo)) {
            if (semesterInfo.enrolmentRegEndMillis < currentTimestamp) {
                setStep01Status(STEP_START + DONE);
                setStep02Status(STEP_CONT + DONE);
                setStep03Status(STEP_END + DONE);
            } else if (
                semesterInfo.enrolmentValidEndMillis < currentTimestamp &&
                currentTimestamp <= semesterInfo.enrolmentRegEndMillis
            ) {
                setStep01Status(STEP_START + DONE);
                setStep02Status(STEP_CONT + DONE);
                setStep03Status(STEP_END + ACTIVE);
            } else if (
                semesterInfo.enrolmentReqEndMillis < currentTimestamp &&
                currentTimestamp <= semesterInfo.enrolmentValidEndMillis
            ) {
                setStep01Status(STEP_START + DONE);
                setStep02Status(STEP_CONT + ACTIVE);
                setStep03Status(STEP_END);
            } else if (
                semesterInfo.enrolmentReqBgnMillis < currentTimestamp &&
                currentTimestamp <= semesterInfo.enrolmentReqEndMillis
            ) {
                setStep01Status(STEP_START + ACTIVE);
                setStep02Status(STEP_CONT);
                setStep03Status(STEP_END);
            } else {
                console.log('currentTimestamp : ' + currentTimestamp);
                console.log('enrolmentRegEndMillis : ' + semesterInfo.enrolmentRegEndMillis);
                console.log('enrolmentValidEndMillis : ' + semesterInfo.enrolmentValidEndMillis);
                console.log('enrolmentReqEndMillis : ' + semesterInfo.enrolmentReqEndMillis);
                setStep01Status(STEP_START);
                setStep02Status(STEP_CONT);
                setStep03Status(STEP_END);
            }
        }
    }, [semesterInfo]);

    return (
        <div className='apply-step-box'>
            <div className='apply-step-list'>
                <div className={'course-req ' + step01Status}>
                    <div className='step-icon'></div>
                    <div className='status'></div>
                    <div className='step-txt'>
                        <span className='step-tit'>수강신청</span>
                        <span className='step-date'>~{convertTimestampToDate(semesterInfo.enrolmentReqEndMillis)}</span>
                    </div>
                </div>
                <div className={'univ-vaild ' + step02Status}>
                    <div className='step-icon'></div>
                    <div className='status'></div>
                    <div className='step-txt'>
                        <span className='step-tit'>
                            수강신청 <br /> 본교검증
                        </span>
                        <span className='step-date'>
                            ~{convertTimestampToDate(semesterInfo.enrolmentValidEndMillis)}
                        </span>
                    </div>
                </div>
                <div className={'univ-reg ' + step03Status}>
                    <div className='step-icon'></div>
                    <div className='status'></div>
                    <div className='step-txt'>
                        <span className='step-tit'>
                            개설대학 <br /> 수강등록
                        </span>
                        <span className='step-date'>~{convertTimestampToDate(semesterInfo.enrolmentRegEndMillis)}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EnrolmentProcessStatus;
